import React from 'react';

const PlanPreviewCard = ({
  label,
  cap,
  numClicks,
  variant = 'current',
  details = [],
}) => {
  const formattedCap = `$${cap.toLocaleString()}`;
  const clickSummary = `${numClicks.toLocaleString()} clicks / month`;
  const metrics = [
    {
      label: 'Monthly cap',
      value: formattedCap,
      className: 'plan-preview-card__cap-value',
    },
    {
      label: 'Included traffic',
      value: clickSummary,
      className: 'plan-preview-card__summary',
    },
    ...details.filter((detail) => detail && detail.value),
  ];

  return (
    <div className={`plan-preview-card plan-preview-card--${variant}`}>
      <div className="plan-preview-card__surface">
        <span className="label-eyebrow">{label}</span>

        <div className="plan-preview-card__metrics">
          {metrics.map((metric) => (
            <div key={metric.label} className="plan-preview-card__metric">
              <span className="plan-preview-card__metric-label">{metric.label}</span>
              <span className={metric.className || 'plan-preview-card__summary'}>
                {metric.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanPreviewCard;
